import api from "@/plugins/api/EntryPoint";
import axios from "axios";

export default {
  /**
   * ✅ ИСПРАВЛЕНО: Получить счета пользователя
   * Теперь с правильными параметрами для POST-запроса.
   */
  getAccounts(callBackFn, credentials = null, sessionId = null) {
    const store = require("@/store").default;
    let data = {};
    if (sessionId) {
      data.session_id = sessionId;
    } else if (credentials) {
      data.username = credentials.username;
      data.password = credentials.password;
    }
    const makeRequest = (reqData) =>
      api.post(
        "bills",
        reqData,
        (response) => {
          if (
            response &&
            response.detail &&
            response.detail.includes("Сессия недействительна")
          ) {
            store.commit("Auth/SET_SESSION_ID", null);
            if (credentials) {
              // retry with credentials
              makeRequest({
                username: credentials.username,
                password: credentials.password,
              });
              return;
            }
          }
          let accountsData = {};
          if (response && response.bills) {
            response.bills.forEach((account) => {
              const key = account.accountNumber || account.id;
              accountsData[key] = account;
            });
          }
          callBackFn(accountsData);
        },
        false,
        true
      );
    makeRequest(data);
  },

  /**
   * ✅ Добавить новый счет
   */
  addAccount(payload, cb, sessionId = null, credentials = null) {
    let data = { ...payload };
    if (sessionId) {
      // Удаляем username/password если они есть в payload
      delete data.username;
      delete data.password;
      data.session_id = sessionId;
    } else if (credentials) {
      data.username = credentials.username;
      data.password = credentials.password;
    }
    return api.post("add_account", data, cb, false, true);
  },

  // --- Остальные методы сохранены ---

  async importAccounts(callBackFn) {
    return api.get("ls/import-old", callBackFn);
  },

  capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  },

  prepareAccount(account) {
    return {
      accountNumber: account.ls,
      city: account.city
        ? this.capitalizeFirstLetter(account.city.toLowerCase())
        : "",
      streetType: account.street_typ,
      building: account.building,
      streetName: account.street_nam
        ? this.capitalizeFirstLetter(account.street_nam.toLowerCase())
        : "",
      appartment: account.apartment === "" ? null : account.apartment,
      balance: account.debt ? account.debt : 0,
      accountVerified: account.check_obl,
      ls: account.ls,
      tariff: account.tariff ? account.tariff : 0,
    };
  },

  getAccount(accountNumber, callBackFn) {
    return api.get(`ls/full-search?ls=${accountNumber}`, (response) => {
      let accountData = this.prepareAccount(response.balance);
      callBackFn(accountData);
    });
  },

  async refreshToken(cb) {
    return await api.get(`auth/refresh-token`, (response) => {
      return cb(response);
    });
  },

  storeAccount(accountNumber, cb) {
    const store = require("@/store").default;
    const credentials = store.state.Auth.userCredentials;

    return api.post(
      "ls/add-account",
      {
        username: credentials?.username || "",
        password: credentials?.password || "",
        contract_number: accountNumber,
        last_payment: 0,
      },
      (response) => {
        return cb(response);
      }
    );
  },

  async nativeAuth(nativeData) {
    return await axios
      .post(process.env.VUE_APP_API_ENDPOINT_URL + "userAuth", nativeData)
      .catch((error) => console.log(error));
  },

  googleAuth(nativeData) {
    return axios
      .post(process.env.VUE_APP_API_ENDPOINT_URL + "googleAuth", nativeData)
      .catch((error) => console.log(error));
  },

  deleteAccountByNumber(accountNumber, callBackFn) {
    return api.post(
      "settings/delete-account",
      { ls: accountNumber },
      callBackFn
    );
  },

  deleteUser() {
    return api.post("settings/delete-user");
  },

  guestMode(guest, cb) {
    return api.put("settings/set-guest", { guest: guest }, cb);
  },

  getGuestMode(callBackFn) {
    return api.get("settings/guest", callBackFn);
  },

  getSubscriptionStatus(callBackFn) {
    return api.get("settings/get-user-status", callBackFn);
  },

  async login(username, password) {
    try {
      const response = await api.post("auth", { username, password });
      return response.data;
    } catch (err) {
      console.error("Ошибка login:", err);
      throw err;
    }
  },

  async fetchBills(token) {
    try {
      const response = await api.post("bills", { token });
      return response.data;
    } catch (err) {
      console.error("Ошибка fetchBills:", err);
      throw err;
    }
  },

  /**
   * ✅ ОБНОВЛЕНО: Авторизация с возможностью указать счет
   * @param {object} params - { username, password, account_id }
   * @returns {Promise} - Ответ с сервера
   */
  async loginBills(params) {
    // Проверка входных параметров
    if (!params.username || !params.password) {
      console.error("Ошибка loginBills: Отсутствует логин или пароль");
      return { status: "error", message: "Невірний логін або пароль" };
    }

    try {
      // Формируем данные для запроса
      const requestData = {
        username: params.username,
        password: params.password,
      };

      // Если передан account_id, добавляем его в запрос
      if (params.account_id) {
        requestData.account_id = params.account_id;
        console.log("Добавлен account_id в запрос API:", params.account_id);
      }

      // Отладочный лог
      console.log(
        "Отправка запроса loginBills с параметрами:",
        JSON.stringify(requestData, (key, value) =>
          key === "password" ? "***" : value
        )
      );

      const response = await api.post("bills", requestData, null, false, true);

      // Проверяем ответ API
      if (response && response.data) {
        const result = response.data;
        // Проверяем вложенную ошибку: {status: "success", data: {status: "fail", message: "..."}}
        if (
          result.status === "success" &&
          result.data &&
          result.data.status === "fail"
        ) {
          return {
            status: "error",
            message: result.data.message || "Невірний логін або пароль",
          };
        }
        return result;
      } else {
        console.error("Ошибка loginBills: Некорректный ответ от API");
        return { status: "error", message: "Ошибка при обращении к серверу" };
      }
    } catch (err) {
      console.error("Ошибка loginBills:", err);

      // Специальная обработка ошибки 401
      if (err.response && err.response.status === 401) {
        return { status: "error", message: "Невірний логін або пароль" };
      }

      // Обработка других ошибок
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Ошибка при обращении к серверу";
      throw { status: "error", message: errorMessage };
    }
  },
};
